import useMerchantStore from 'store/merchant'

const useTransactions = () => {
  const merchantTransaction = useMerchantStore(
    (state) => state.merchantTransaction
  )
  const merchantTransactionLoading = useMerchantStore(
    (state) => state.merchantTransactionLoading
  )

  return {
    merchantTransaction,
    merchantTransactionLoading,
  }
}

export default useTransactions
